





























import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { MungBeanAllocateDetailList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import constant from '@/utils/constant'

@Component({
  components: { VQuery, VTable },
})
export default class MungBeanAllocateDetailListPage extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    createTimeDaterange: [],
  }
  private tableTotal = 0
  private tableData: any[] = []
  private tableCurrntPage = 1
  private summary: any = null

  private queryModels: Array<QueryModel> = [
    { title: '批次号', param: 'batchNo' },
    { title: '标的用户ID', param: 'targetUserId' },
    { title: '收款人ID', param: 'receiverUserId' },
    { title: '段类型', param: 'segmentType', type: 'select', selectData: constant.MungBeanAllocateSegmentType },
    { title: '十代代数', param: 'genNo' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]

  private queryOperation: Array<TableOperation> = []

  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '批次号', param: 'batchNo', width: 200, overflow: true },
    { title: '标的用户ID', param: 'targetUserId', width: 110 },
    { title: '标的用户', param: 'targetUserNickname', width: 120 },
    { title: '收款人ID', param: 'receiverUserId', width: 110 },
    { title: '收款人编号', param: 'receiverUserNo', width: 120 },
    { title: '收款人', param: 'receiverNickname', width: 120 },
    { title: '身份', param: 'receiverUserTypeLabel', width: 90 },
    { title: '段类型', param: 'segmentTypeLabel', width: 130 },
    { title: '十代代数', param: 'genNo', width: 90 },
    { title: '配置比例', param: 'configRatio', width: 90 },
    { title: '应得', param: 'theoryQty' },
    { title: '实得', param: 'actualQty' },
    { title: '流水ID', param: 'wealthRecordId', width: 100 },
    { title: '创建时间', param: 'createTime', width: 160, formatter: DateFormat },
  ]

  public activated() {
    this.loadData()
  }

  public created() {
    this.loadData()
  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await MungBeanAllocateDetailList(param)
    this.tableTotal = result.total || 0
    this.tableData = result.list || []
    this.summary = result.summary || null
  }

  private getRequestParam() {
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    delete param.createTimeDaterange
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 10)
    return param
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
